
export const contrilInsuranceMax = {
    '336' : {
        'GP3361': 30
    }
}
export const contrilInsuranceProfessionRelation = {
    '336': {
        'GP3361': [
            {
                code: 'A0306001',
                desc: '护林员',
                val: '4'
            },
            {
                code: 'A0404001',
                desc: '筛选破碎工',
                val: '5'
            },
            {
                code: 'A0404007',
                desc: '磨矿工',
                val: '5'
            },
            {
                code: 'A0601035',
                desc: '混凝土工人（不参与模具操作或机械操作，不涉高作业，不涉及切割及焊接）',
                val: '4'
            },
            {
                code: 'A0605008',
                desc: '木工、油漆工',
                val: '4'
            },
            {
                code: 'A0606015',
                desc: '中央空调系统安装及维护人员',
                val: '5'
            },
            {
                code: 'A0609007',
                desc: '装饰石材生产工人',
                val: '5'
            },
            {
                code: 'A0704005',
                desc: '铁合金冶炼工人',
                val: '4'
            },
            {
                code: 'A0706001',
                desc: '氧化铝制取工人',
                val: '5'
            },
            {
                code: 'A0709009',
                desc: '金属挤压工人',
                val: '5'
            },
            {
                code: 'A0714032',
                desc: '冲压工人',
                val: '5'
            },
            {
                code: 'A0714056',
                desc: '铁工厂工人',
                val: '5'
            },
            {
                code: 'A0741005',
                desc: '工程机械修理工',
                val: '4'
            },
            {
                code: 'A0748033',
                desc: '猪\牛\羊屠宰加工工',
                val: '4'
            },
            {
                code: 'A0748045',
                desc: '冰块制造工人',
                val: '3'
            },
            {
                code: 'A0751007',
                desc: '药物制剂工',
                val: '2'
            },
            {
                code: 'A0814010',
                desc: '广告招牌绘制人员（高空）',
                val: '5'
            },
            {
                code: 'A1223004',
                desc: '金属、化工废物回收人员',
                val: '5'
            },
            {
                code: 'A1223005',
                desc: '一般废旧物资回收人员',
                val: '5'
            },
            {
                code: 'A1529004',
                desc: '收货、送货员（非四轮机动车）',
                val: '5'
            },
            {
                code: 'A1531020',
                desc: '道路清洁工（非高速、非城市快速路）',
                val: '5'
            },
            {
                code: 'A1602002',
                desc: '保安员（负责巡逻任务）',
                val: '4'
            }
        ]
    }
}

export const contrilInsuranceMaxText = {
    '336' : {
        'GP3361': '30万',
    }
}

export const trialControl = {
    '342': [
        'insureHouseAddress',
        'groupName',
        'groupCardType',
        'groupCardId',
        'personsInfo',
        'industryInfos',
        'archiveInfo'
    ],
    '345': [
        'insureHouseAddress',
        'groupName',
        'groupCardType',
        'groupCardId',
        'personsInfo',
        'industryInfos',
        'archiveInfo'
    ],
    '80102': [
        // 'insureHouseAddress',
        // 'groupName',
        // 'groupCardType',
        // 'groupCardId',
         'personsInfo',
        // 'archiveInfo'
    ],
    '80126': [
        // 'insureHouseAddress',
        // 'groupName',
        // 'groupCardType',
        // 'groupCardId',
         'personsInfo',
        // 'archiveInfo'
    ]
}

// 电子发票产品
export const invoiceApplyETicketControl = [
    60101, 60103, 60102, 324, 325, 326, 329, 80102, 80126, 103, 80129
]
// 电子发票产品 特殊文案提示
export const invoiceApplyETicketSpecialCopyControl = {

}



// WEBPACK FOOTER //
// ./src/util/insuranc-profession-control.js